import { RefreshIcon } from '@heroicons/react/solid';
import React from 'react';

export function SimpleSpinner({
    isSmall,
    className = '',
    noPaddings = false,
}: {
    isSmall?: boolean;
    className?: string;
    noPaddings?: boolean;
}) {
    return (
        <div className={`flex w-full items-center justify-center ${noPaddings ? '' : 'py-2'}`}>
            <div className="flex items-center animate-spin">
                <RefreshIcon
                    className={` ${
                        isSmall ? 'w-5 h-5' : 'w-8 h-8'
                    } ${className} text-gray-600 -scale-y-100`}
                />
            </div>
        </div>
    );
}
